<template>
  <div class="wrap" >
    <div class="contents">
      <div class="title">
        <div class="logo">
          <img src="@/assets/image/logo.png" :alt="$t('layout.logo.alt')">
        </div>
        <div class="name">{{ $t('layout.logo.text') }}</div>
      </div>
      <router-view/>
    </div>
    <msg-dialog
      v-for="message in messageList"
      :key="message.key"
      :type="message.type"
      :text="message.code !== undefined ? $t(message.code, message.field) : message.text"
      @yes="closeDialog(message.key, 1)"
      @no="closeDialog(message.key,  0)"
      @cancel="closeDialog(message.key, -1)"
    />
    <wait-cursor-modal v-show="showWait"/>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import MsgDialog from '@/components/MsgDialog.vue';
import WaitCursorModal from '@/components/WaitCursorModal.vue';

export default {
  components: {
    MsgDialog,
    WaitCursorModal,
  },
  data: () => ({
  }),
  created() {
    document.title = this.$t('sys.title');
    this.initUrlQuery();
  },
  methods: {
    closeDialog(key, value){
      this.closePopMsg({key, value})
    },
    ...mapActions([
      'initUrlQuery',
      'closePopMsg',
    ]),
  },
  computed: {
    ...mapGetters([
      'messageList',
      'showWait',
    ])
  }
};
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@300;400;500;700&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Noto Sans KR', sans-serif;
}

ul li {
  list-style: none;
  a {
    text-decoration: none;
    color: #000;
  }
}

a {
  text-decoration: none;
}

body {
  background-color: #eaeaea;
  display: table;
  margin: 0 auto;
}
</style>
<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: 100vh;
  display: table-cell;
  vertical-align: middle;

  .contents {
    background-color: #fff;
    border: 1px solid #cecece;
    padding: 40px;
    min-width: 350px;
    margin: 0 auto;

    .title {
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: center;

      .name {
        font-size: 28px;
        font-weight: 500;
        margin-left: 10px;
        margin-top: -4px;
      }
    }
  }
}
</style>
